import React, { Component } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { I18n } from 'react-i18nify';
import Layout from './components/Layout';
import ClientList from './components/ClientList';
import Report from './components/report/Report';
import FetchData from './components/FetchData';
import ProposalForm from './components/ProposalForm';
import WebReport from './components/WebReport';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ConditionalRedirectRoute from './components/api-authorization/ConditionalRedirectRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';

import './localization/i18n';

interface PropsShape {}

export default class App extends Component<PropsShape> {
    static displayName = App.name;

    render() {
        return (
            <I18n
                render={() => (
                    <ConditionalRedirectRoute>
                        <Routes>
                            <Route path='/' element={<Navigate to='/proposals' replace />} />
                            <Route
                                path='/authentication/logged-out'
                                element={<Navigate to='/authentication/login' replace />}
                            />
                            <Route path="/report" element={<AuthorizeRoute><Report /></AuthorizeRoute>} />
                            <Route element={<Layout />}>
                                <Route path="/proposals" element={<AuthorizeRoute><ClientList /></AuthorizeRoute>} />
                                <Route path='/proposals/:id' element={<AuthorizeRoute><WebReport /></AuthorizeRoute>} />
                                <Route path='/proposals/:id/edit' element={<AuthorizeRoute><ProposalForm /></AuthorizeRoute>} />
                                <Route path="/fetch-data" element={<AuthorizeRoute><FetchData /></AuthorizeRoute>} />
                                <Route
                                    path={`${ApplicationPaths.ApiAuthorizationPrefix}/*`}
                                    element={<ApiAuthorizationRoutes />}
                                />
                            </Route>
                        </Routes>
                    </ConditionalRedirectRoute>
                )}
            />
        );
    }
}
